"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleFormatter = void 0;
const ArticleFormValidator_1 = require("./ArticleFormValidator");
class ArticleFormatter {
    static anzahl(options) {
        return ArticleFormValidator_1.ArticleFormValidator.anzahl(options);
    }
}
exports.ArticleFormatter = ArticleFormatter;
//# sourceMappingURL=ArticleFormatter.js.map